import { render, staticRenderFns } from "./loginSso.vue?vue&type=template&id=10fac90e&scoped=true&"
import script from "./loginSso.vue?vue&type=script&lang=js&"
export * from "./loginSso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fac90e",
  null
  
)

export default component.exports